// extracted by mini-css-extract-plugin
export default {"toolbarPosition":"pricingAdpriceScaleTypeGrid_toolbarPosition__pT0MR"};